export const listOfIndustries = [
  'Agriculture & Agribusiness',
  'Forestry',
  'Fishing & Aquaculture',
  'Mining & Quarrying',
  'Oil & Gas',
  'Manufacturing',
  'Food & Beverage Processing',
  'Textile, Apparel & Fashion',
  'Chemical & Pharmaceutical',
  'Cement & Building Materials',
  'Automotive & Assembly',
  'Plastics & Packaging',
  'Power Generation & Distribution',
  'Renewable Energy',
  'Utilities',
  'Construction',
  'Real Estate & Property Development',
  'Architecture & Engineering',
  'Wholesale & Retail Trade',
  'E-commerce',
  'Import & Export',
  'FMCG Distribution',
  'Transportation',
  'Logistics & Supply Chain',
  'Aviation',
  'Maritime & Ports',
  'Courier & Delivery Services',
  'Information Technology (IT)',
  'Software & SaaS',
  'Telecommunications',
  'Fintech',
  'Edtech',
  'Healthtech',
  'Media Tech',
  'Banking',
  'Insurance',
  'Asset Management',
  'Microfinance',
  'Investment & Venture Capital',
  'Accounting & Auditing',
  'Consulting',
  'Legal Services',
  'Human Resources & Recruitment',
  'Marketing & Advertising',
  'Business Process Outsourcing',
];
